import axios from 'axios'
/**
 * @description
 * A function that generates another function...
 * Returns the function for handling datatable api calls given a base query
 * using Vue Api Query models.
 * @param {Model} query
 */
const generateFetchDataFunction = (
    model,
    includes = [],
    appends = [],
    formatResponse = null
) => {
    if (!includes) includes = []
    if (!appends) appends = []
    const dtFetchData = async (filters = null, pagination = null) => {
        let query = generateQuery(model, includes, appends)
        if (pagination) {
            if (pagination.page) query = query.page(pagination.page)
            if (pagination.sortBy) {
                query = query.orderBy(
                    (pagination.descending ? '-' : '') + pagination.sortBy
                )
            }
            if (pagination.rowsPerPage) {
                query = query.limit(pagination.rowsPerPage)
            }
        }
        if (filters && filters.length > 0) {
            filters.forEach(filter => {
                query = query.whereIn(filter.field, filter.value)
            })
        }
        let data = await query.get()
        if (formatResponse) data = formatResponse(data)
        return data
    }
    return dtFetchData
}

const generateQuery = (model, includes = [], appends = []) => {
    includes.forEach(include => {
        model = model.include(include)
    })
    //appends.forEach(append => {
    model = model.append(appends)
    //})
    return model
}

const getFetchDataFunction = (
    url,
    includes = [],
    appends = [],
    format = null
) => {
    const dtFetchData = async (filters = null, pagination = null) => {
        let query = url
        // if (query.substr(query.length - 1) !== '?') query += '?'
        if (query.indexOf('?') <= -1) query += '?'
        if (includes && includes.length > 0) {
            query += '&include='
            includes.forEach((include, idx) => {
                if (idx > 0) query += ','

                query += include
            })
        }
        if (appends && appends.length > 0) {
            query += '&append='
            appends.forEach((append, idx) => {
                if (idx > 0) query += ','
                query += append
            })
        }
        if (filters && filters.length > 0) {
            filters.forEach(filter => {
                query += '&filter[' + filter.field + ']=' + filter.value
            })
        }
        if (pagination) {
            if (pagination.page) query += '&page=' + pagination.page
            if (pagination.sortBy) {
                query +=
                    '&sort=' +
                    (pagination.descending ? '-' : '') +
                    pagination.sortBy
            }
            if (pagination.rowsPerPage) {
                query += '&limit=' + pagination.rowsPerPage
            }
        }
        console.log(query)
        let data = await axios.get(query)
        if (format) data = format(data)
        if (data.data.data) return data.data
        return data
    }
    return dtFetchData
}

const generateDeleteItemFunction = model => {
    let mdl = model
    const dtDeleteItem = primaryKey => {
        let query = {}
        query[primaryKey.field] = primaryKey.value
        let item = new mdl(query)
        item.delete()
    }
    return dtDeleteItem
}

export {
    generateDeleteItemFunction,
    generateFetchDataFunction,
    generateQuery,
    getFetchDataFunction,
}
